export default __webpack_public_path__ + "5778aa54e65b6537716cd9c0042cce16.png";